'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bidispatcher = bidispatcher;

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _index = require('../index.js');

function bidispatcher(Target) {

    function mapDispatchToProps(dispatch) {
        return {
            biActions: (0, _redux.bindActionCreators)(_index.redux.actions, dispatch)
        };
    }

    return (0, _reactRedux.connect)(null, mapDispatchToProps)(Target);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-bi/dist/redux/ReactDecorator.js
// module id = 886
// module chunks = 0